import { takeLatest } from 'redux-saga/effects';
import { UPDATE_MANAGER } from 'managerialTree/redux.actionTypes';
import updateManager from './updateManager';

export default function* () {
    yield takeLatest(UPDATE_MANAGER, updateManager);
}
